/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './modal.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/@shared/ui/modal/modal.component';
import * as i3 from '../../../../../app/@shared/ui/modal/modal.service';
const styles_ModalComponent:any[] = [i0.styles];
export const RenderType_ModalComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ModalComponent,data:{}});
export function View_ModalComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{modalContent:0}),(_l()(),i1.ɵted((null as any),
      ['\n		'])),(_l()(),i1.ɵeld(16777216,[[1,3],['modalContent',1]],(null as any),
      0,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n  ']))],(null as any),(null as any));
}
export function View_ModalComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'fl-modal',([] as any[]),
      (null as any),(null as any),(null as any),View_ModalComponent_0,RenderType_ModalComponent)),
      i1.ɵdid(114688,(null as any),0,i2.ModalComponent,[i3.ModalService,[1,i1.Injector]],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ModalComponentNgFactory:i1.ComponentFactory<i2.ModalComponent> = i1.ɵccf('fl-modal',
    i2.ModalComponent,View_ModalComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkLXdlYmFwcC1jb21wYXQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC91aS9tb2RhbC9tb2RhbC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQtd2ViYXBwLWNvbXBhdC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3VpL21vZGFsL21vZGFsLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkLXdlYmFwcC1jb21wYXQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC91aS9tb2RhbC9tb2RhbC5jb21wb25lbnQudHMuTW9kYWxDb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkLXdlYmFwcC1jb21wYXQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC91aS9tb2RhbC9tb2RhbC5jb21wb25lbnQudHMuTW9kYWxDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcblx0XHQ8bmctY29udGFpbmVyICNtb2RhbENvbnRlbnQ+PC9uZy1jb250YWluZXI+XG4gICIsIjxmbC1tb2RhbD48L2ZsLW1vZGFsPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7MERDQUE7TUFBQSxXQUNFO01BQUE7TUFBQSxnQkFBMkM7OztvQkNEN0M7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/$$_gendir/app/@shared/ui/modal/modal.component.ngfactory.ts